import { classes, icons } from '@portal/components'

const Icon = ({
  name,
  className,
}: {
  name: keyof typeof icons | null
  className?: string
}) => {
  if (!name) return null
  const IconComponent = icons[name]
  return IconComponent ? <IconComponent className={className} /> : null
}

export const AppTenantMenuButton = ({
  onClick,
  label,
  disabled,
  icon,
  iconPosition = 'left',
  className,
}: {
  onClick?: () => void
  label: string
  disabled?: boolean
  icon?: keyof typeof icons
  iconPosition?: 'left' | 'right'
  className?: string
}) => (
  <button
    className={classes(
      'relative flex w-full cursor-default text-left select-none items-center rounded-lg px-2 py-1.5 outline-none transition-colors hover:bg-background-overlay-hovered focus-visible:bg-background-overlay-hovered disabled:hover:bg-transparent disabled:focus-visible:bg-transparent disabled:border-none disabled:focus-visible:border-none',
      className,
    )}
    onClick={onClick}
    disabled={disabled}
    role="menuitem"
  >
    {icon && iconPosition === 'left' && (
      <Icon name={icon} className="mr-2 h-4 w-4 text-foreground-subtle" />
    )}
    {label}
    {icon && iconPosition === 'right' && (
      <Icon name={icon} className="ml-2 h-4 w-4 text-foreground-subtle" />
    )}
  </button>
)

export default AppTenantMenuButton
